/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PropertyStatusEnum = 1 | 2 | 3 | 4;

export const PropertyStatusEnum = {
    NUMBER_1: 1 as PropertyStatusEnum,
    NUMBER_2: 2 as PropertyStatusEnum,
    NUMBER_3: 3 as PropertyStatusEnum,
    NUMBER_4: 4 as PropertyStatusEnum
};

